// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".order-warning-template .detailSection[data-v-6f70539d] {\n  padding: 25px 15px !important;\n}\n.order-warning-template .detailSection .item .lang[data-v-6f70539d] {\n  width: 90px;\n}\n.order-warning-template .detailSection .flex1[data-v-6f70539d] {\n  -webkit-box-flex: 1;\n      -ms-flex: 1;\n          flex: 1;\n}", ""]);
// Exports
module.exports = exports;
